import { render } from "./PasswordResetSentPage.vue?vue&type=template&id=41e8b573&scoped=true"
import script from "./PasswordResetSentPage.vue?vue&type=script&lang=js"
export * from "./PasswordResetSentPage.vue?vue&type=script&lang=js"

import "./PasswordResetSentPage.vue?vue&type=style&index=0&id=41e8b573&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e8b573"]])

export default __exports__